import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ExpenseTypeService {

    constructor(private apiService: ApiService) { }

    getExpenseTypes(queryParams: HttpParams) {
        return this.apiService.get('expense-types', queryParams);
    }

    createExpenseType(data: any) {
        return this.apiService.post('expense-types', data);
    }

    updateExpenseType(id: any, data: any) {
        return this.apiService.update('expense-types/' + id, data);
    }

    deleteExpenseType(id: any) {
        return this.apiService.delete('expense-types/' + id);
    }
}
